import React from "react";
import { Space, Table } from "antd";
import parser from "../../../../../../shared/helpers/parser";
import DeleteButton from "../../../../../../shared/components/deleteButton";
import EditButton from "../../../../../../shared/components/editButton";

const AnexoVEncargadosDeProteccionRadiologicaTable = props => {
  return (
    <Table
      size="small"
      columns={ [
        { title: 'Id', dataIndex: 'IdEncargadoDeProteccionRadiologica', key: 'IdEncargadoDeProteccionRadiologica' },
        //{ title: 'Id Equipo Radiologico', dataIndex: 'IdEquipoRadiologico', key: 'IdEquipoRadiologico' },
        { title: 'Cuil', dataIndex: 'Cuil', key: 'Cuil' },
        { title: 'Titulo Profesional', dataIndex: 'TituloProfesional', key: 'TituloProfesional' },
        { title: 'Matricula Profesional', dataIndex: 'MatriculaProfesional', key: 'MatriculaProfesional' },
        { title: 'Nro Habilitacion', dataIndex: 'NroHabilitacion', key: 'NroHabilitacion' },
        //{ title: 'Fecha Insert', dataIndex: 'FechaInsert', key: 'FechaInsert', render: text => <span>{ parser.date(text) }</span> },
        props.formMode ? { title: '', dataIndex: 'Actions', key: 'Actions',
          render: (text, record) => {
            return <Space size="small">
              <EditButton onClick={ () => props.onEdit(record) }/>
              <DeleteButton onConfirm={ () => props.onRemove(record) }/>
              {/* { !record.IdEncargadoDeProteccionRadiologica ? <DeleteButton onConfirm={ () => props.onRemove(record) }/> : '' } */}
            </Space>
          }
        } : {},
      ] } 
      dataSource={ props.EncargadosDeProteccionRadiologica }
      rowKey={(record) => record.Id}
      pagination={ { hideOnSinglePage: true, pageSize: 10, showSizeChanger: false } }
    />
  );
}

export default AnexoVEncargadosDeProteccionRadiologicaTable;